import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { throwErrorMessage } from "../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./image.constants";
import { EKwikUIImageLoadingType, EKwikUIImageType } from "./image.definitions";
import { isValidKeyValue } from "./image.validation";

@Component({
  selector: "kwikui-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"]
})
export class KwikUIImageComponent implements OnInit, OnChanges {
  @Input() altText: string = DEFAULT_VALUES.altText;

  @Input() class: string = DEFAULT_VALUES.class;

  @Input() html: any = DEFAULT_VALUES.html;

  @Input() id: string = DEFAULT_VALUES.id;

  @Input() imageSrc: string = DEFAULT_VALUES.imageSrc;

  @Input() imageType: EKwikUIImageType = DEFAULT_VALUES.imageType;

  @Input() loadingType: EKwikUIImageLoadingType = DEFAULT_VALUES.loadingType;

  @Input() styles: string = DEFAULT_VALUES.styles;

  @Output() onClick = new EventEmitter<any>();

  safeImageSrc: any;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.handleImageBasedOnImageType();
  }

  ngOnChanges(changes: SimpleChanges) {
    const verifyChange = (key: string) => {
      return changes.hasOwnProperty(key) && !changes[key].firstChange;
    };

    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }

    if (verifyChange("imageSrc")) {
      this.imageSrc = changes.imageSrc.currentValue;
      this.handleImageBasedOnImageType();
    }

    if (verifyChange("altText")) {
      this.altText = changes.altText.currentValue;
    }

    if (verifyChange("imageType")) {
      this.imageType = changes.imageType.currentValue;
      this.handleImageBasedOnImageType();
    }

    if (verifyChange("loadingType")) {
      this.loadingType = changes.loadingType.currentValue;
    }
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-image",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  handleOnClick(e: any): void {
    this.onClick.emit(e);
  }

  private cleanImageSrc(): void {
    this.imageSrc = this.imageSrc.trim();
  }

  private sanitizeImage(): void {
    this.safeImageSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(
      this.imageSrc
    );
  }

  handleImageBasedOnImageType(): void {
    this.cleanImageSrc();

    switch (this.imageType) {
      case EKwikUIImageType.BASE64:
        if (!this.imageSrc.startsWith("data:image")) {
          this.imageSrc = `data:image/png;base64,${this.imageSrc}`;
        }
        break;
      case EKwikUIImageType.URL:
        break;
      default:
        break;
    }

    this.sanitizeImage();
  }
}
